import { render, staticRenderFns } from "./table.vue?vue&type=template&id=cbbd45b0&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=cbbd45b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbd45b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbbd45b0')) {
      api.createRecord('cbbd45b0', component.options)
    } else {
      api.reload('cbbd45b0', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=cbbd45b0&scoped=true", function () {
      api.rerender('cbbd45b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/commodity/table.vue"
export default component.exports